import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { LoginPage } from '../components-core/authorization/LoginPage';
import { RegistrationPage } from '../components-core/authorization/RegistrationPage';
import { RestorePasswordPage } from '../components-core/authorization/RestorePasswordPage';
import { NewPasswordPage } from '../components-core/authorization/NewPasswordPage';
import { Landing } from '../pages/';
import { TransactionAlreadyPaid } from '../sections/landing/TransactionAlreadyPaid';
import { TransactionCompleted } from '../sections/landing/TransactionCompleted';
import { TransactionWrong } from '../sections/landing/TransactionWrong';
import EnrollmentForm from '../sections/landing/order-forms/EnrollmentForm';

export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/login" />} />
    <Route path="/" element={<EnrollmentForm formIdentifier={'zapisy'} />} exact />
    <Route path="/login" element={<LoginPage />} exact />
    <Route path="/registration" element={<RegistrationPage />} exact />
    <Route path="/restore-password" element={<RestorePasswordPage />} exact />
    <Route path="/restore-password/new-password/:uidb64/:token" element={<NewPasswordPage />} exact />
    <Route path="/transakcja-zakonczona/" element={<TransactionCompleted />} />
    <Route path="/bledna-transakcja/" element={<TransactionWrong />} />
    <Route path="/transakcja-oplacona/" element={<TransactionAlreadyPaid />} />
    <Route path="zapisy" element={<EnrollmentForm formIdentifier={'zapisy'} />}/>
  </Routes>
);
